export const CHANGE_HEADERMENU = 'side/change_head_menu'
export const CHANGE_HEADMENUIDS = 'side/change_head_menu_ids'
export const CHANGE_MENUS = 'side/change_menu'
export const CHANGE_MENUIDS = 'side/change_menu_ids'
